<template>
  <div>
    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Chọn tài khoản</CCol>
      <CCol col="9">
        <vue-multiselect v-model="filter.userIdSelected" :options="userList"
                         placeholder="-- Chọn 1 tài khoản theo id" label="name" track-by="id"
                         :custom-label="customLabelUserList" :show-labels="false"
                         :multiple="false" :taggable="false"></vue-multiselect>
      </CCol>
    </CRow>
    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Chọn action</CCol>
      <CCol col="9">
        <vue-multiselect v-model="filter.actionSelected" :options="actionList"
                         placeholder="-- Được chọn nhiều action" label="name" track-by="id"
                         :multiple="true" :taggable="true"></vue-multiselect>
      </CCol>
    </CRow>

    <hr/>

    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Từ ngày</CCol>
      <CCol col="9">
        <b-form-datepicker v-model="filter.dateFrom" @input="onInputDateFrom"></b-form-datepicker>
      </CCol>
    </CRow>
    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Đến ngày</CCol>
      <CCol col="9">
        <b-form-datepicker v-model="filter.dateTo" @input="onInputDateTo"></b-form-datepicker>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'
import {filterSidebarList} from '@/mixins/log/filter'

export default {
  name: "FilterPanel",
  mixins: [
    filterSidebarList
  ],
  components: {
    VueMultiselect
  }
}
</script>

<style scoped>

</style>
